import {dateStrToDay} from "../date-utils";
import {toBigInt} from "../utils";
import type {FieldDesc, Id} from "./mate-types";

export const INVALIDATE: unique symbol = Symbol("INVALIDATE");
export type Invalidate = typeof INVALIDATE;

export const getIdAsKey = (id: Id): string => {
  return Array.isArray(id) ? (id.length === 1 ? id[0] : JSON.stringify(id)) : id ?? "null";
};

/** Converts a field value as the server or a mutation sends it into the form the cache holds. */
export const hydrateField = (type: FieldDesc["type"] | undefined, val: unknown) => {
  switch (type) {
    case "date":
      return typeof val === "string" || typeof val === "number" ? new Date(val) : val;
    case "day":
      return typeof val === "string" ? dateStrToDay(val) : val;
    case "bigint":
      return typeof val === "string" || typeof val === "number" ? toBigInt(String(val)) : val;
    default:
      return val;
  }
};
